import { SWRConfiguration } from 'swr';

import { fetcher } from './fetcher';

// Default conservador do projeto (Req 3.1-3.6): reproduz o comportamento sem cache
// da app atual — cada montagem rebusca dados frescos. O cache fica provisionado para
// opt-in por hook, que sobrescreve estas opções localmente sem mutar este objeto.
// Tipar como SWRConfiguration delega ao compilador a validação das flags (sem `any`)
// e centraliza as opções aqui, evitando literais duplicados no Root.tsx (Req 3.8).
export const swrConfig: SWRConfiguration = {
  fetcher,
  revalidateOnFocus: false,
  revalidateOnReconnect: false,
  revalidateIfStale: false,
  dedupingInterval: 0,
  keepPreviousData: false,
};
